export enum FeedbackType {
  ANONYMOUS = "ANONYMOUS",
  NON_ANONYMOUS = "NON_ANONYMOUS",
}
